import {Colors, FlexBox} from "@brg/ui";
import {QueueButtonFilled} from "../../designerEditView/styles";
import {FC, useCallback, useEffect, useMemo} from "react";
import {TabBtnText, TagBtnWrapper, TagsMobBtn} from "../../../components/TagsMobBtn/TagsMobBtn";
import {Loader} from "../../../features/QueuePaymenrt/components/Loader/Loader";
import {useSelector} from "react-redux";
import {useBreakpoint} from "@brg/ui";
import {
    selectorOrder
} from "../../../features/QueuePaymenrt/slices/OrderSlice";
import {useProfile} from "../../../../core/hooks/auth/useProfile";
import {useAuth} from "../../../../core/hooks/auth/useAuth";
import {useTranslation} from "react-i18next";
import {LayoutConst} from "../../../../core";
import styled, { css } from "styled-components";
import {ApprovedIcon} from "../../../icons/ApprovedIcon";
import {LongreadShopButtons} from "../../../components/LongreadShopButtons";
import {BookPaymentData} from "../../../hooks/useGetBookPaymentData";
import { AppTester } from "supporting";

const QueueButtonsWrapper = styled(FlexBox)`
    ${TagBtnWrapper} {
      padding: 7px 20px;
      
      svg {
        width: 12px;
        height: 12px;
      }
    }
    ${TabBtnText} {
      font-size: 17px;
      font-weight: 400;
      line-height: 22px;
    }
  
  ${QueueButtonFilled} {
    height: 38px !important;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    
    background-color: #1F1F1F !important;
    color: #FFFFFF !important;
    
    &:hover {
      background-color: #2A2A2A !important;
    }
    
    &:active {
      background-color: #151515 !important;
    }
    
    &:disabled {
      background-color: #909090 !important;
      color: #6C7073 !important;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      height: 38px;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
      height: 44px!important;
    }
  }

  @media(max-width: ${LayoutConst.screen.s}px) {
    width: calc(100% - 20px);
    margin-right: 10px;
  }
`

const BoughtStatus = styled(FlexBox)`
  color: ${Colors.galBlack47};
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  align-items: center;
  gap: 4px;
  letter-spacing: -0.02em;
  
  svg {
    path {
      fill: ${Colors.galBlack47};
    }
  }
`
const QueueNumberTitle = styled(FlexBox)<{ hide?: boolean }>`

${({ hide}) => hide && css` display: none`};
  color: ${Colors.galBlack31};
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
`

export const QueueButtons: FC<{ showQueue: boolean, setShowQueue: (val: boolean) => void, book?: any, cards: any, goToBookBuyProcessing?: () => void, bookPaymentData: BookPaymentData, showTagsButton?: boolean; }> = ({showQueue, setShowQueue, bookPaymentData, book, cards, goToBookBuyProcessing, showTagsButton = true}) => {

    if (!book || !bookPaymentData) {
        return null;
    }

    const orderData = useSelector(selectorOrder)
    const bookCard = orderData?.bookCard || null
    const profile = useProfile()
    const auth = useAuth()

    const is744BP = useBreakpoint(LayoutConst.screen.s)
    const is940BP = useBreakpoint(LayoutConst.screen.md)
    const isBook = AppTester.isBooksDeziiign() || AppTester.isBooksGallllery();

    const { setBookPaymentInfoTime, price, copyCard, priceLoading } = bookPaymentData

    const { t } = useTranslation()

    const isArtJournal = useMemo(() => 
      // (book && book?.projectId === '0e2f5bce32fb4a67b4db4a880a192dbd')
      (book.distributionTypes?.includes(1))
    , [book])

    // временное решение по обновлению очереди
    useEffect(() => {
      setTimeout(() => setBookPaymentInfoTime && setBookPaymentInfoTime(Date.now()), 300)
    }, [])

    const onBuyCopy = useCallback(async () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    
        if (!price || copyCard || priceLoading) {
            return
        }
        if (!profile?.accountId && !isArtJournal) {
            auth.emit('quick_login');
            return
        }
        if (isArtJournal && bookCard) {
          window.open( process.env.REACT_APP_URL_GALLERY + '/card/' + `${book.subscriptionId || '91130b413e41417e8dca26b5e80cc60d'}` + '?tab=variants', '_SELF');
          return;
        }
        if (goToBookBuyProcessing) {
          goToBookBuyProcessing();
          return;
        }

    }, [book, cards, bookCard, price, copyCard, priceLoading, isArtJournal, bookCard, goToBookBuyProcessing])

    // console.log('tst', isArtJournal)

    
    if (is744BP) return <QueueButtonsWrapper width={'100%'} align="flex-end">
        <FlexBox width={'100%'} gy={16} align="flex-end" direction="column" directionMobile="column">
            <FlexBox gx={24} justify="space-between" width={'100%'} align="center">
              {showTagsButton && <>
                <QueueNumberTitle hide={!isBook}>{t('card_constructor.number_in_queue')}</QueueNumberTitle>
                <TagsMobBtn hide={!isBook} flag={showQueue} onClick={setShowQueue} customText={bookCard?.sequenceItem?.number.slice(-4)}/>
              </>}
            </FlexBox>
            {copyCard ? <BoughtStatus><ApprovedIcon fill={Colors.galBlack47} display />{t('card_constructor.book_bought')}</BoughtStatus> : <QueueButtonFilled hide={!isArtJournal && !isBook} disabled={copyCard || priceLoading} onClick={onBuyCopy}>
                {!priceLoading && <>{t(`card_constructor.${isArtJournal ? 'buy_subscribe' : 'buy_book_copy'}`)}  {!isArtJournal && (price?.priceRouble?.rouble || 0)} {!isArtJournal && '₽'}</>}
            </QueueButtonFilled>}
            <LongreadShopButtons project={book}/>
        </FlexBox>
    </QueueButtonsWrapper>

    return <QueueButtonsWrapper align="flex-end">
        <QueueButtonsWrapper gx={!is940BP ? 16 : 0} gy={is940BP ? 16 : 0} align="flex-end" directionMobile="column">
            {copyCard
              ? <BoughtStatus><ApprovedIcon fill={Colors.galBlack47} display />{t('card_constructor.book_bought')}</BoughtStatus>
              : <QueueButtonFilled hide={!isBook} disabled={copyCard || priceLoading} onClick={onBuyCopy}>
            {!priceLoading && <>
                  {t(`card_constructor.${isArtJournal ? 'buy_subscribe' : 'buy_book_copy'}`)} {!isArtJournal && (price?.priceRouble?.rouble || 0)} {!isArtJournal && '₽'}
                </>}
            </QueueButtonFilled>}
            <QueueButtonsWrapper gx={24}>
                <LongreadShopButtons project={book}/>
                {showTagsButton && <TagsMobBtn hide={!isBook} flag={showQueue} onClick={setShowQueue} customText={copyCard ? copyCard?.sequenceItem?.number.slice(-4) : bookCard?.sequenceItem?.number.slice(-4)}/>}
            </QueueButtonsWrapper>
        </QueueButtonsWrapper>
    </QueueButtonsWrapper>
}import {Colors, FlexBox} from "@brg/ui";
import {QueueButtonFilled} from "../../designerEditView/styles";
import {FC, useCallback, useEffect, useMemo} from "react";
import {TabBtnText, TagBtnWrapper, TagsMobBtn} from "../../../components/TagsMobBtn/TagsMobBtn";
import {Loader} from "../../../features/QueuePaymenrt/components/Loader/Loader";
import {useSelector} from "react-redux";
import {useBreakpoint} from "@brg/ui";
import {
    selectorOrder
} from "../../../features/QueuePaymenrt/slices/OrderSlice";
import {useProfile} from "../../../../core/hooks/auth/useProfile";
import {useAuth} from "../../../../core/hooks/auth/useAuth";
import {useTranslation} from "react-i18next";
import {LayoutConst} from "../../../../core";
import styled, { css } from "styled-components";
import {ApprovedIcon} from "../../../icons/ApprovedIcon";
import {LongreadShopButtons} from "../../../components/LongreadShopButtons";
import {BookPaymentData} from "../../../hooks/useGetBookPaymentData";
import { AppTester } from "supporting";

const QueueButtonsWrapper = styled(FlexBox)`
    ${TagBtnWrapper} {
      padding: 7px 20px;
      
      svg {
        width: 12px;
        height: 12px;
      }
    }
    ${TabBtnText} {
      font-size: 17px;
      font-weight: 400;
      line-height: 22px;
    }
  
  ${QueueButtonFilled} {
    height: 38px !important;
    font-size: 17px;
    font-weight: 600;
    line-height: 22px;
    
    background-color: #1F1F1F !important;
    color: #FFFFFF !important;
    
    &:hover {
      background-color: #2A2A2A !important;
    }
    
    &:active {
      background-color: #151515 !important;
    }
    
    &:disabled {
      background-color: #909090 !important;
      color: #6C7073 !important;
    }

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      height: 38px;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
      height: 44px!important;
    }
  }

  @media(max-width: ${LayoutConst.screen.s}px) {
    width: calc(100% - 20px);
    margin-right: 10px;
  }
`

const BoughtStatus = styled(FlexBox)`
  color: ${Colors.galBlack47};
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  align-items: center;
  gap: 4px;
  letter-spacing: -0.02em;
  
  svg {
    path {
      fill: ${Colors.galBlack47};
    }
  }
`
const QueueNumberTitle = styled(FlexBox)<{ hide?: boolean }>`

${({ hide}) => hide && css` display: none`};
  color: ${Colors.galBlack31};
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
`

export const QueueButtons: FC<{ showQueue: boolean, setShowQueue: (val: boolean) => void, book?: any, cards: any, goToBookBuyProcessing?: () => void, bookPaymentData: BookPaymentData, showTagsButton?: boolean; }> = ({showQueue, setShowQueue, bookPaymentData, book, cards, goToBookBuyProcessing, showTagsButton = true}) => {

    if (!book || !bookPaymentData) {
        return null;
    }

    const orderData = useSelector(selectorOrder)
    const bookCard = orderData?.bookCard || null
    const profile = useProfile()
    const auth = useAuth()

    const is744BP = useBreakpoint(LayoutConst.screen.s)
    const is940BP = useBreakpoint(LayoutConst.screen.md)
    const isBook = AppTester.isBooksDeziiign() || AppTester.isBooksGallllery();

    const { setBookPaymentInfoTime, price, copyCard, priceLoading } = bookPaymentData

    const { t } = useTranslation()

    const isArtJournal = useMemo(() => 
      // (book && book?.projectId === '0e2f5bce32fb4a67b4db4a880a192dbd')
      (book.distributionTypes?.includes(1))
    , [book])

    // временное решение по обновлению очереди
    useEffect(() => {
      setTimeout(() => setBookPaymentInfoTime && setBookPaymentInfoTime(Date.now()), 300)
    }, [])

    const onBuyCopy = useCallback(async () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    
        if (!price || copyCard || priceLoading) {
            return
        }
        if (!profile?.accountId && !isArtJournal) {
            auth.emit('quick_login');
            return
        }
        if (isArtJournal && bookCard) {
          window.open( process.env.REACT_APP_URL_GALLERY + '/card/' + `${book.subscriptionId || '91130b413e41417e8dca26b5e80cc60d'}` + '?tab=variants', '_SELF');
          return;
        }
        if (goToBookBuyProcessing) {
          goToBookBuyProcessing();
          return;
        }

    }, [book, cards, bookCard, price, copyCard, priceLoading, isArtJournal, bookCard, goToBookBuyProcessing])

    // console.log('tst', isArtJournal)

    
    if (is744BP) return <QueueButtonsWrapper width={'100%'} align="flex-end">
        <FlexBox width={'100%'} gy={16} align="flex-end" direction="column" directionMobile="column">
            <FlexBox gx={24} justify="space-between" width={'100%'} align="center">
              {showTagsButton && <>
                <QueueNumberTitle hide={!isBook}>{t('card_constructor.number_in_queue')}</QueueNumberTitle>
                <TagsMobBtn hide={!isBook} flag={showQueue} onClick={setShowQueue} customText={bookCard?.sequenceItem?.number.slice(-4)}/>
              </>}
            </FlexBox>
            {copyCard ? <BoughtStatus><ApprovedIcon fill={Colors.galBlack47} display />{t('card_constructor.book_bought')}</BoughtStatus> : <QueueButtonFilled hide={!isArtJournal && !isBook} disabled={copyCard || priceLoading} onClick={onBuyCopy}>
                {!priceLoading && <>{t(`card_constructor.${isArtJournal ? 'buy_subscribe' : 'buy_book_copy'}`)}  {!isArtJournal && (price?.priceRouble?.rouble || 0)} {!isArtJournal && '₽'}</>}
            </QueueButtonFilled>}
            <LongreadShopButtons project={book}/>
        </FlexBox>
    </QueueButtonsWrapper>

    return <QueueButtonsWrapper align="flex-end">
        <QueueButtonsWrapper gx={!is940BP ? 16 : 0} gy={is940BP ? 16 : 0} align="flex-end" directionMobile="column">
            {copyCard
              ? <BoughtStatus><ApprovedIcon fill={Colors.galBlack47} display />{t('card_constructor.book_bought')}</BoughtStatus>
              : <QueueButtonFilled hide={!isBook} disabled={copyCard || priceLoading} onClick={onBuyCopy}>
            {!priceLoading && <>
                  {t(`card_constructor.${isArtJournal ? 'buy_subscribe' : 'buy_book_copy'}`)} {!isArtJournal && (price?.priceRouble?.rouble || 0)} {!isArtJournal && '₽'}
                </>}
            </QueueButtonFilled>}
            <QueueButtonsWrapper gx={24}>
                <LongreadShopButtons project={book}/>
                {showTagsButton && <TagsMobBtn hide={!isBook} flag={showQueue} onClick={setShowQueue} customText={copyCard ? copyCard?.sequenceItem?.number.slice(-4) : bookCard?.sequenceItem?.number.slice(-4)}/>}
            </QueueButtonsWrapper>
        </QueueButtonsWrapper>
    </QueueButtonsWrapper>
}